import { render, staticRenderFns } from "./TransferBookingCard.vue?vue&type=template&id=a8debc36&scoped=true"
import script from "./TransferBookingCard.vue?vue&type=script&lang=js"
export * from "./TransferBookingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8debc36",
  null
  
)

export default component.exports